module.exports = require('browserify-sha3').SHA3Hash



//////////////////
// WEBPACK FOOTER
// ./~/keccakjs/browser.js
// module id = 1473
// module chunks = 0 1 2